export const ACTIONS = {
  SET_LOADING: "SET_LOADING",
  SET_RELOAD_ALL: "SET_RELOAD_ALL",
  IS_LOGGEDIN: "IS_LOGGEDIN",
  SET_CUSTOMERS: "SET_CUSTOMERS",
}
